import { UserRole } from "@assoanalytics/app/core/models/user/user-role";
import { environment } from "@assoanalytics/environments/environment";

export const sidebarElements = {
  dashboard: {
    displayName: "Dashboard",
    iconName: "layout-dashboard",
    route: "/dashboard",
    module: "dashboard",
    roles: [UserRole.Net, UserRole.Plant],
  },
  // Clienti
  clients: {
    displayName: "Clienti",
    iconName: "assembly",
    route: "/clienti",
    roles: [UserRole.Net, UserRole.Plant],
    module: "clients",
    children: [
      {
        displayName: "Andamento vendite",
        iconName: "minus",
        route: "/clienti/andamento-vendite",
        component: "SalesTrendComponent",
        roles: [UserRole.Net, UserRole.Plant],
      },
      {
        displayName: "Carte Petrolifere",
        iconName: "minus",
        route: "/clienti/petrolifere",
        component: "WlfuelappSalesTrendPageComponent",
        roles: [UserRole.Net, UserRole.Plant],
      },
      {
        displayName: "Totali per impianto",
        iconName: "minus",
        route: "/clienti/totali-per-impianto",
        component: "PlantsTotalsPageComponent",
        roles: [UserRole.Net, UserRole.Plant],
      },
      {
        displayName: "Fatturato",
        iconName: "minus",
        route: "",
        component: "RevenueComponent",
        roles: [UserRole.Net, UserRole.Plant],
      },
      {
        displayName: "Consumo Veicoli",
        iconName: "minus",
        route: "/clienti/consumo-veicoli",
        component: "VehicleConsumptionPageComponent",
        roles: [UserRole.Net, UserRole.Plant],
      },
    ],
  },

  // Clienti PRO
  bi: {
    displayName: "Clienti PRO",
    iconName: "trophy",
    route: "/clienti-pro",
    module: "bi",
    roles: [UserRole.Net, UserRole.Plant],
    children: [
      {
        displayName: "Business Intelligence",
        iconName: "minus",
        route: "/clienti-pro/looker",
        component: "BiPage",
        roles: [UserRole.Net, UserRole.Plant],
      },
      {
        displayName: "Agente AI",
        iconName: "minus",
        route: "/clienti-pro/query",
        component: "BiPage",
        roles: [UserRole.Net, UserRole.Plant],
      },
    ],
  },
  plants: {
    displayName: "Impianti",
    iconName: "gas-station",
    route: "/impianti",
    roles: [UserRole.Net, UserRole.Plant],
    module: "plants",
    children: [
      {
        displayName: "Riepilogo",
        iconName: "minus",
        route: "/impianti/riepilogo",
        component: "PlantsHomePageComponent",
        roles: [UserRole.Net, UserRole.Plant],
      },
      {
        displayName: "Erogazioni",
        iconName: "minus",
        route: "/impianti/erogazioni",
        component: "TransactionsListPageComponent",
        roles: [UserRole.Net, UserRole.Plant],
      },
      {
        displayName: "Chiusure",
        iconName: "minus",
        route: "/impianti/chiusure",
        component: "ClosureListPageComponent",
        roles: [UserRole.Net, UserRole.Plant],
      },
    ],
  },
  netPro: {
    displayName: "Rete PRO",
    iconName: "brand-netbeans",
    route: "/rete-pro",
    roles: [UserRole.Net],
    module: "netPro",
    children: [
      {
        displayName: "Totali giornalieri",
        iconName: "minus",
        route: "",
        component: "DailyTotalsPageComponent",
        roles: [UserRole.Net],
      },
    ],
  },
  ossPrezzi: {
    displayName: "Osservatorio Prezzi",
    iconName: "binoculars",
    route: "osservatorio-prezzi",
    roles: [UserRole.Plant, UserRole.Net],
    module: "ossPrezzi",
  },
  externalLinks: {
    navCap: "Vai a",
    module: "externalLinks",
    route: "",
  },
  assoPayments: {
    displayName: "Asso Payments",
    iconName: "external-link",

    // impostando il logo si attiva il template alternativo
    customLogoPath: "assets/images/logos/asso-payments-icon-alt.png",

    accentColor: "#00b2aa",
    customDisplayName: [
      { value: "ASSO", accent: false },
      { value: "Payments", accent: true },
    ],
    route: `/external-link?url=${environment["external-links"].payments}`,
    module: "assoPayments",
    blank: false,

    external: true,
    roles: [UserRole.Net],
  },
  assoStations: {
    displayName: "Asso Stations",
    iconName: "external-link",

    // impostando il logo si attiva il template alternativo
    customLogoPath: "assets/images/logos/asso-stations-icon-alt.png",
    accentColor: "#f5821f",
    customDisplayName: [
      { value: "ASSO", accent: false },
      { value: "Stations", accent: true },
    ],
    route: `/external-link?url=${environment["external-links"].stations}`,
    module: "assoStations",
    tooltip:
      "Scopri come semplificare i flussi di lavoro e la gestione dei tuoi punti vendita.",
    external: true,
    blank: false,
    roles: [UserRole.Net],
  },
};
